import React from 'react'
import { GoogleWebfontsWeights } from '../googleWebfontHelper/use_google_webfonts_list'

export const FontWeightOptionsGoogleFontsOrDefault = ({
  googleWebfontWeights,
}: {
  googleWebfontWeights: GoogleWebfontsWeights
}) => {
  if (!googleWebfontWeights) return <FontWeightOptionsDefaults />

  return (
    <>
      {googleWebfontWeights.map((variant) => (
        <option key={variant} value={variant}>
          {variant}
        </option>
      ))}
    </>
  )
}

const FontWeightOptionsDefaults = () => {
  return (
    <>
      <option value="300">
        {i18n.t('fundraising_events.manage.live_widgets.configurator.font_weight_value_light')}
      </option>
      <option value="400">
        {i18n.t('fundraising_events.manage.live_widgets.configurator.font_weight_value_regular')}
      </option>
      <option value="700">
        {i18n.t('fundraising_events.manage.live_widgets.configurator.font_weight_value_bold')}
      </option>
    </>
  )
}
